import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ce2d2bdc&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=ce2d2bdc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2d2bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce2d2bdc')) {
      api.createRecord('ce2d2bdc', component.options)
    } else {
      api.reload('ce2d2bdc', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ce2d2bdc&scoped=true", function () {
      api.rerender('ce2d2bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/baseManagement/availabilityReport/detail.vue"
export default component.exports